import { Model } from '@/models';

export class ClaimCheckTerms extends Model {
	public body: null | string = null;
	public footer: any[] | null = null;
	public header: any[] | null = null;
}
